import { BRIDGE } from 'core/constants/bridge'
import { getUA } from 'core/singleton'
import { STORE_ROOT_PROPS } from 'core/store/global'
import { requestBridge } from 'core/util/default'
import React, { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'

interface SkeletonLiveCardProps {
  layoutEl: HTMLDivElement | null
}

const SkeletonLiveCard: React.FC<SkeletonLiveCardProps> = ({ layoutEl }) => {
  const root = useRecoilValue(STORE_ROOT_PROPS)
  const useMultipleSkeleton = !root?.bridge
  const { isSDK } = getUA()

  useEffect(() => {
    return () => {
      if (!layoutEl || !isSDK) return
      requestBridge(BRIDGE.DOM_RECT, {
        domRect: layoutEl.getBoundingClientRect(),
        elementId: 'broadcastTable',
      })
    }
  }, [layoutEl, isSDK])

  return (
    <StyledSkeletonWrapper>
      <StyledSkeletonLiveCard>
        <div className="skeleton" />
      </StyledSkeletonLiveCard>
      {useMultipleSkeleton && (
        <>
          <StyledSkeletonLiveCard>
            <div className="skeleton" />
          </StyledSkeletonLiveCard>
          <StyledSkeletonLiveCard>
            <div className="skeleton" />
          </StyledSkeletonLiveCard>
          <StyledSkeletonLiveCard>
            <div className="skeleton" />
          </StyledSkeletonLiveCard>
        </>
      )}
    </StyledSkeletonWrapper>
  )
}

const StyledSkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 50px;

  @media screen and (max-width: 768px) {
    gap: 20px;
    margin-bottom: 20px;
  }
`

const StyledSkeletonLiveCard = styled.div`
  width: 100%;
  height: 240px;
  z-index: 1;
  border-radius: 6px;
  .skeleton {
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
    border-radius: inherit;
  }
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
  @media screen and (max-width: 768px) {
    height: 134px;
  }
`
export default SkeletonLiveCard
